module.exports = __webpack_public_path__ + "img/ef3.1e57f810.jpg";